// extracted by mini-css-extract-plugin
module.exports = {"box":"splash_box__wrAgF","bounce":"splash_bounce__2hJhB","bounce-1":"splash_bounce-1__Wy1F7","backgroundScreen":"splash_backgroundScreen__3nVsu"};